import { render } from "./UserReportPage.vue?vue&type=template&id=7caf1b6d&scoped=true&ts=true"
import script from "./UserReportPage.vue?vue&type=script&lang=ts"
export * from "./UserReportPage.vue?vue&type=script&lang=ts"

import "./UserReportPage.vue?vue&type=style&index=0&id=7caf1b6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caf1b6d"]])

export default __exports__